<template>
  <div class="order-item">
    <van-checkbox v-if="showCheckbox" @change="toggleGoods" style="padding-right: 0.32rem;min-width: 0.36rem;" v-model="goods.checked" icon-size="0.36rem" checked-color="#E1244E" />
    <div class="img" :style="{backgroundImage: `url(${goods.cover})`}"></div>
    <div class="info">
      <p class="van-multi-ellipsis--l2">{{ goods.title }}</p>
      <span v-if="goods.size">{{ goods.size }} <van-icon v-if="sizeDrop" class="drop-icon" name="arrow-down" /></span>
    </div>
    <div class="price" v-if="priceShow">
      <p>{{ goods.price }}</p>
      <span>x{{ goods.count }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'order-item',
  props: {
    goods: {
      type: Object,
      default() {
        return {}
      }
    },
    showCheckbox: {
      type: Boolean,
      default: false
    },
    priceShow: {
      type: Boolean,
      default: false
    },
    parIndex: {
      type: Number,
      default: 0
    },
    sizeDrop: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      checked: false
    }
  },
  methods: {
    toggleGoods() {
      this.$emit('toggleGoods', {
        parIndex: this.parIndex
      })
    }
  }
}
</script>

<style scoped lang="stylus">
.order-item
  display flex
  .img
    min-width 176px
    width 176px
    height 176px
    margin-right 24px
    border-radius 5px
    background-size cover
    background-position center center
    background-repeat no-repeat
  .info
    flex 1
    &>p
      margin-bottom 25px
      line-height 32px
      font-size 26px
      color #000000
    &>span
      display flex
      align-items center
      font-size 24px
      color #A0A0A0
  .price
    min-width 140px
    width 140px
    text-align right
    &>p
      margin-bottom 18px
      font-size 26px
      color #000000
      font-weight bold
    &>span
      font-size 22px
      color #ADADAD
</style>
